const expireDateValidation = ({ days, emptyMsg, incorrectMsg }) => {
  if (!days || !days?.toString().length) {
    return {
      status: "notOk",
      message: emptyMsg
    };
  }

  const justNumbers = /^[0-9]+$/.test(days)
  if (!justNumbers) {
    return {
      status: "notOk",
      message: "Digite apenas números!"
    };
  }

  const test = days >= 1 && days <= 30;
  if (test) {
    return {
      status: "ok",
      message: ""
    };
  } else {
    return {
      status: "notOk",
      message: incorrectMsg
    };
  }
};

export { expireDateValidation };